import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * Keeps a block's server-rendered content in step with the selected variant. On product select it
 * finds its counterpart (same `data-block-id`) in the re-rendered section and morphs its children,
 * following the pattern of `product-inventory.js`.
 *
 * Used by the Zauq price savings and product WhatsApp blocks.
 */
class ZauqVariantSync extends Component {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    super.connectedCallback();
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section = null;
  }

  /**
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const { blockId } = this.dataset;
        if (!blockId) return;

        const updated = html.querySelector(`zauq-variant-sync[data-block-id="${CSS.escape(blockId)}"]`);
        if (!updated) return;

        morph(this, updated, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[zauq-variant-sync] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('zauq-variant-sync')) {
  customElements.define('zauq-variant-sync', ZauqVariantSync);
}
